/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Knowledge_Figure_LabelInputs */

const en_directory_knowledge_figure_label = /** @type {(inputs: Directory_Knowledge_Figure_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`records`)
};

const zh_directory_knowledge_figure_label = /** @type {(inputs: Directory_Knowledge_Figure_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`条记录`)
};

/**
* | output |
* | --- |
* | "records" |
*
* @param {Directory_Knowledge_Figure_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_figure_label = /** @type {((inputs?: Directory_Knowledge_Figure_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_Figure_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_figure_label(inputs)
	return zh_directory_knowledge_figure_label(inputs)
});
export { directory_knowledge_figure_label as "directory.knowledge.figure_label" }